module.exports = __webpack_public_path__ + "static/Cookies-30d19d496300fe34ced09bd9bcaf04e0.jpg";